import React from 'react';
import PropTypes from 'prop-types';
import { InstagramEmbed } from 'react-social-media-embed';
import withCookieConsentSocialMedia from './withCookieConsentSocialMedia';

const BBSocialMediaEmbedInstagram = ({ postURL }) => (
  <div>
    <InstagramEmbed width="100%" url={postURL} />
  </div>
);

BBSocialMediaEmbedInstagram.propTypes = {
  postURL: PropTypes.string.isRequired,
};

export default withCookieConsentSocialMedia(BBSocialMediaEmbedInstagram);
